import apiClient from './apiClient';

export interface CacheStatistics {
    cacheName: string;
    source: string;
    keyCount: number;
    totalMemoryUsage: number;
    formattedMemoryUsage?: string;
    hitRatio: number;
    hits: number;
    misses: number;
    instanceId?: string;
}

export interface CacheHealth {
    cacheAvailable: boolean;
    timestamp: number;
    [key: string]: any;
}

export const getCacheInfo = async () => {
    return apiClient.get<Record<string, Record<string, any>>>('/api/cache/info');
};

export const getCacheStatistics = async (cacheName: string) => {
    return apiClient.get<CacheStatistics>(`/api/cache/stats/${cacheName}`);
};

export const gatherClusterStats = async () => {
    return apiClient.get<Record<string, CacheStatistics[]>>('/api/cache/stats/cluster/gather');
};

export const resetClusterStats = async () => {
    return apiClient.post<{ status: string; message: string }>('/api/cache/stats/cluster/reset');
};

export const getCacheKeys = async (cacheName: string) => {
    return apiClient.get<string[]>(`/api/cache/keys/${cacheName}`);
};

export const getCacheHealth = async () => {
    return apiClient.get<CacheHealth>('/api/cache/health');
};

export const evictAllCaches = async () => {
    return apiClient.post<{ status: string; message: string }>('/api/cache/evict/all');
};

export const evictCache = async (cacheName: string) => {
    return apiClient.post<{ status: string; message: string }>(`/api/cache/evict/${cacheName}`);
};

export const evictCacheKey = async (cacheName: string, key: string) => {
    return apiClient.post<{ status: string; message: string }>(`/api/cache/evict/${cacheName}/${encodeURIComponent(key)}`);
};

export const warmUpCache = async () => {
    return apiClient.post<{ status: string; message: string }>('/api/cache/warmup');
};
